import { AuditEntity } from "@app/common";
import { CurrencyPipe } from "@angular/common";
import { CreditType } from "../enums/credit-type";
import { Api, Column, Display, FormField, prop, required } from "@messaia/cdk";

@Api('creditreason')
export class CreditReason extends AuditEntity {
    /**
     * @property
     */
    @required()
    @FormField({ row: 1 })
    @Column({})
    @Display($localize`:@@name:Name`)
    name: string;

    /**
     * @property
     */
    @prop()
    @FormField({
        row: 2,
        enumType: CreditType
    })
    @Display($localize`:@@type:Type`)
    type: CreditType;

    /**
     * @property
     */
    @prop()
    @FormField({ row: 3, inputType: 'number' })
    @Column({
        content: (x: CreditReason) => new CurrencyPipe('de-DE', '€').transform(x.net),
    })
    @Display($localize`:@@amountNet:Amount net`)
    net: number;

    /**
     * @property
     */
        @prop()
        @FormField({ row: 4 })
        @Column({})
        @Display($localize`:@@key:Key`)
        key: string;

    /**
     * @property
     */
    @prop()
    @FormField({ row: 5 })
    @Column({ event: 'toggle' })
    @Display($localize`:@@enabled:Enabled`)
    enabled: boolean;
    
}